import {motion} from "framer-motion";
import PropTypes from "prop-types";
import Icon from "../../assets/btn-close-Icon.svg";
export const CloseButton = ({onClick}) => (
    <motion.button
        onClick={onClick}
        className="transition-transform"
        whileHover={{scale: 1.12}}
        whileTap={{scale: 0.9}}
    >
        <motion.img
            src={Icon}
            alt="Cerrar"
            className="w-8 h-8"
            animate={{rotate: [0, -3, 3, 0]}}
            transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut",
            }}
        />
    </motion.button>
);

CloseButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};
